import MapHelper from "./MapHelper";
import MapDivIcon from "./MapDivIcon";
declare let L:any;

class Maps {
    private $_contactMainMap        =   $("#contact-map");
    private contactMainMapElement   =   null;
    private $_contactSubMaps        =   $(".contact-sub-map");
    private contactSubMapElements   =   {};

    public constructor() {
        this.initMap();
    }

    private initMap() {
        console.log("Maps loaded and initalizing!");
        this.initContactMaps();
    }

    private initContactMaps() {
        if (this.$_contactMainMap.length) {
            let bounds = L.latLngBounds();
            let titles = this.$_contactMainMap.attr('data-titles').split(',');
            let lats = this.$_contactMainMap.attr('data-lat').split(',');
            let lngs = this.$_contactMainMap.attr('data-lng').split(',');
            let images = this.$_contactMainMap.attr('data-img').split(',');

            let objects = [];
            for (let i = 0; i < titles.length; i++) {
                objects.push({
                    title: titles[i],
                    lat: parseFloat(lats[i]),
                    lng: parseFloat(lngs[i]),
                    img: images[i]
                });
                bounds.extend(L.latLng(objects[objects.length - 1].lat, objects[objects.length - 1].lng));
            }

            this.contactMainMapElement = new MapHelper(this.$_contactMainMap[0]);
            this.contactMainMapElement.getMap().setMaxZoom(15).fitBounds(bounds);
            this.contactMainMapElement.getMap().setView(bounds.getCenter());
            if (this.contactMainMapElement.getMap().getZoom() > 13) {
                this.contactMainMapElement.getMap().setZoom(13);
            }
            window['main_map_el'] = this.contactMainMapElement.getMap();
            window['main_map_bounds'] = bounds;

            for (let i of objects) {
                let divIcon = new MapDivIcon(i.title, i.img);
                L.marker([i.lat, i.lng], {
                    icon: divIcon.getDivIcon()
                }).addTo(this.contactMainMapElement.getMap());
            }
        }

        if (this.$_contactSubMaps.length) {
            this.$_contactSubMaps.each((i, e) => {
                const lat = parseFloat($(e).attr('data-lat'));
                const lng = parseFloat($(e).attr('data-lng'));
                const title = $(e).attr('data-title');
                const elID = $(e).attr('id');
                this.contactSubMapElements[elID] = new MapHelper(elID, [lat, lng]);
                this.contactSubMapElements[elID].getMap().setView([lat, lng], 15);
                let divIcon = new MapDivIcon(title);
                L.marker([lat, lng], {
                    icon: divIcon.getDivIcon()
                }).addTo(this.contactSubMapElements[elID].getMap());
            });
        }

        $(".contact-block .nav .nav-item .nav-link").on('shown.bs.tab', (e) => {
            const id = $(e.target).attr('data-sub-id');
            this.contactSubMapElements['contact-sub-map-' + id.toString()].refreshMap();
        });

        $(".park-nav .btn").on('shown.bs.tab', (e) => {
            const href = $(e.target).attr('href');
            if ($(href).length) {
                $(href).find('.contact-sub-map').each((i, e) => {
                    const id = $(e).attr('id');
                    if (id in this.contactSubMapElements) {
                        this.contactSubMapElements[id].refreshMap();
                    }
                });
            }
        });
    }
}

export default Maps;